import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axios';
import Swal from 'sweetalert2';
import { FaEnvelope, FaLock, FaSignInAlt } from 'react-icons/fa';

export default function Login() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/login', formData);
            localStorage.setItem('token', response.data.token);
            
            Swal.fire({
                icon: 'success',
                title: 'Welcome Back!',
                text: 'You have successfully logged in.',
                showConfirmButton: false,
                timer: 1500
            });

            setTimeout(() => {
                navigate('/');
                window.location.reload();
            }, 1500);

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Login Failed',
                text: 'Invalid email or password. Please try again.'
            });
        }
    };

    return (
        <div className="container mt-5 fade-in-up">
            <div className="row justify-content-center">
                <div className="col-md-5">
                    <div className="card event-card border-0 p-4">
                        <div className="card-body">
                            <div className="text-center mb-4">
                                <h3 className="fw-bold text-dark">Welcome Back 👋</h3>
                                <p className="text-muted">Login to access your tickets</p>
                            </div>
                            
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3 text-start">
                                    <label className="form-label fw-bold text-secondary">Email Address</label>
                                    <div className="input-group shadow-sm">
                                        <span className="input-group-text bg-white border-end-0"><FaEnvelope className="text-muted" /></span>
                                        <input type="email" name="email" className="form-control border-start-0 ps-0" placeholder="Enter your email" onChange={handleChange} required />
                                    </div>
                                </div>
                                <div className="mb-4 text-start">
                                    <label className="form-label fw-bold text-secondary">Password</label>
                                    <div className="input-group shadow-sm">
                                        <span className="input-group-text bg-white border-end-0"><FaLock className="text-muted" /></span>
                                        <input type="password" name="password" className="form-control border-start-0 ps-0" placeholder="Enter your password" onChange={handleChange} required />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-gradient w-100 rounded-pill d-flex align-items-center justify-content-center shadow-sm">
                                    <FaSignInAlt className="me-2" /> Login
                                </button>
                            </form>

                            <div className="text-center mt-4">
                                <p className="text-muted mb-0">Don't have an account? <Link to="/register" className="text-primary fw-bold text-decoration-none">Sign Up here</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}